import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface TableColumn {
  key: string;
  label: string;
  format?: (value: any) => string;
  renderHtml?: boolean;
}

export interface TableRow {
  [key: string]: any;
}

@Component({
  selector: 'app-raw-data-table',
  templateUrl: './raw-data-table.component.html',
  styleUrls: ['./raw-data-table.component.scss']
})
export class RawDataTableComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: TableRow[] = [];
  @Input() keyValueMode: boolean = false; // For 206AB style key-value tables
  @Input() keyValueData?: { [key: string]: any }; // For key-value data

  constructor(private sanitizer: DomSanitizer) { }

  get displayData(): TableRow[] {
    if (this.keyValueMode && this.keyValueData) {
      // Convert key-value object to array of rows
      return Object.entries(this.keyValueData).map(([key, value]) => ({
        field: key,
        value: value
      }));
    }
    return this.data || [];
  }

  formatValue(column: TableColumn, row: TableRow): string {
    const value = row[column.key];
    if (column.format) {
      return column.format(value);
    }
    return value || 'N/A';
  }

  getFormattedValue(column: TableColumn, row: TableRow): SafeHtml | string {
    const formatted = this.formatValue(column, row);
    if (column.renderHtml) {
      return this.sanitizer.bypassSecurityTrustHtml(formatted);
    }
    return formatted;
  }

  get hasData(): boolean {
    if (this.keyValueMode) {
      return Boolean(this.keyValueData && Object.keys(this.keyValueData ?? {}).length > 0);
    }
    return this.data && this.data.length > 0;
  }
}

